import { useCallback } from "react"
import { useComputed } from "@preact/signals-react"
import { isEmpty } from "@ui-seeker/utils"

import { idNameBatch } from "../@signals"


export default function useModalInfo() {
    const isOpen = useComputed(() => !isEmpty(idNameBatch.value))

    const openBatchDrawer = useCallback((id, batchName) => {
        idNameBatch.value = {
            id: id,
            name: batchName
        }
    }, [])

    return {
        openBatchDrawer,
        isOpen
    }
}